import { render } from "./ExternalKyc.vue?vue&type=template&id=35371df1&scoped=true"
import script from "./ExternalKyc.vue?vue&type=script&lang=js"
export * from "./ExternalKyc.vue?vue&type=script&lang=js"

import "./ExternalKyc.vue?vue&type=style&index=0&id=35371df1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35371df1"]])

export default __exports__